/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type userRevisionQueryVariables = {
    readonly id: string;
};
export type userRevisionQueryResponse = {
    readonly person: {
        readonly hasErrors: boolean | null;
        readonly person: {
            readonly __typename: string;
            readonly id: string;
            readonly revision: string | null;
        } | null;
    } | null;
};
export type userRevisionQuery = {
    readonly response: userRevisionQueryResponse;
    readonly variables: userRevisionQueryVariables;
};



/*
query userRevisionQuery(
  $id: ID!
) {
  person(id: $id) {
    hasErrors
    person {
      __typename
      id
      revision
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "person",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "PersonPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "hasErrors",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "person",
        "storageKey": null,
        "args": null,
        "concreteType": "Person",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "__typename",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "revision",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "userRevisionQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "userRevisionQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "userRevisionQuery",
    "id": null,
    "text": "query userRevisionQuery(\n  $id: ID!\n) {\n  person(id: $id) {\n    hasErrors\n    person {\n      __typename\n      id\n      revision\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '475e75c741f6b866473771a29de91a1f';
export default node;
